import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';

import { buscarUsuarios } from '../../actions/usuarios';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import NuevoUsuario from './NuevoUsuario';
import EditarUsuario from './EditarUsuario';
import EliminarUsuario from './EliminarUsuario';

const tiposUsuario = [
    { value: 0, label: 'Administrador' },
    { value: 1, label: 'Asistente' }
];

const Usuarios = () => {

    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.usuarios);
    const { usuario } = useSelector(state => state.auth);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
    const [usuarioEliminar, setUsuarioEliminar] = useState(null);

    useEffect(() => {
        dispatch(buscarUsuarios({
            nombre: null, 
            apellido_paterno: null, 
            apellido_materno: null, 
            tipo: null, 
            fecha_inicio: null, 
            fecha_fin: null
        }));
        dispatch(editarBreadcrumb([
            { nombre: 'Usuarios', path: '/usuarios', activo: true }
        ]));
    }, []);

    const handleEditar = (usuarioRow) => {
        setUsuarioSeleccionado(usuarioRow);
    };

    const handleEliminar = (usuarioRow) => {
        setUsuarioEliminar(usuarioRow);
    };

    const handleCerrarEditar = () => {
        setUsuarioSeleccionado(null);
    };

    const handleCerrarEliminar = () => {
        setUsuarioEliminar(null);
    };

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => `${row.nombre || ''} ${row.apellido_paterno || ''} ${row.apellido_materno || ''}`.trim() || '-',
            grow: 2
        },
        {
            name: 'Correo',
            sortable: true,
            selector: row => row.email || '-',
            grow: 2
        },
        {
            name: 'Tipo',
            sortable: true,
            selector: row => tiposUsuario.find(t => t.value === row.tipo)?.label || '-'
        },
        {
            name: 'Creación',
            sortable: true,
            selector: row => row.creacion
                ? new Date(row.creacion).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
                : '-'
        },
        {
            name: '',
            cell: row => (
                <div>
                    {usuario?.permisos?.usuarios?.editar && (
                        <button
                            className="btn btn-sm btn-warning me-1"
                            title="Editar"
                            onClick={() => handleEditar(row)}
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                    )}
                    {usuario?.permisos?.usuarios?.eliminar && (
                        <button
                            className="btn btn-sm btn-danger"
                            title="Eliminar"
                            onClick={() => handleEliminar(row)}
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Usuarios</h4>
                {usuario?.permisos?.usuarios?.agregar && (
                    <button className="btn btn-primary" onClick={() => setNuevoModal(true)}>
                        <i className="fas fa-plus me-1"></i> Nuevo usuario
                    </button>
                )}
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay usuarios registrados"
                />
            </div>

            <NuevoUsuario
                show={nuevoModal}
                handleCerrar={() => setNuevoModal(false)}
            />

            <EditarUsuario
                usuario={usuarioSeleccionado}
                handleCerrar={handleCerrarEditar}
            />

            <EliminarUsuario
                usuario={usuarioEliminar}
                handleCerrar={handleCerrarEliminar}
            />
        </div>
    );
};

export default Usuarios;
